import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Routepath from './Components/routepath';


function App() {
  return (
    
     
   <Routepath/>
    
  );
}

export default App;
